import React from "react";
import "./Footer.css";

export default function Footer() {
  return (
    <p className="Footer">
      <a
        href="https://github.com/Sofie326/react-weather-app"
        target="_blank"
        rel="noreferrer"
      >
        Open-source code
      </a>  by Sofie Berden
    </p>
  );
}
